export const copyTextToClipboard = (text: string): Promise<void> => {
  const textCopyEl = document.createElement("textarea");
  textCopyEl.setAttribute("readonly", "");
  textCopyEl.tabIndex = -1;
  textCopyEl.className = "visually-hidden";
  if (navigator.clipboard) {
    return navigator.clipboard.writeText(text);
  }

  return new Promise((resolve) => {
    textCopyEl.value = text;
    document.body.appendChild(textCopyEl);
    const selection = document.getSelection();

    if (selection) {
      // Store previous selection
      const rangeToRestore =
        selection.rangeCount > 0 && selection.getRangeAt(0);
      textCopyEl.select();
      // @ts-ignore
      document.execCommand("copy");
      // Restore the original selection
      if (rangeToRestore) {
        selection.removeAllRanges();
        selection.addRange(rangeToRestore);
      }
    }

    document.body.removeChild(textCopyEl);
    resolve();
  });
};
